jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$(".btn-primary, .btn-white").each(function () {
  var originalText = $(this).text();
  $(this).html(
    '<div class="slide-in-bottom"><span data-hover="' +
      originalText +
      '">' +
      originalText +
      "</span></div>"
  );
});

/**** Main menu ****/

$(".navi li").each(function () {
  var li = $(this);
  if (li.find("ul li").length > 0) {
    li.append(
      "<a href='javascript:;' rel='nofollow noopener' class='expand icon-expand' onclick='return false;'></a>"
    );
    li.append(
      "<a href='javascript:;' rel='nofollow noopener' class='colapse icon-collapse' onclick='return false;'></a>"
    );
  }
});

$("body").on("click", "a.expand", function () {
  $(this).hide().next().show();
  $(this).parent().siblings().find("ul").slideUp();
  $(this).parent().siblings().find("a.expand").show();
  $(this).parent().siblings().find("a.colapse").hide();
  $(this)
    .parent()
    .find(">ul")
    .addClass("expanded")
    .stop(true, true)
    .slideDown();
});

$("body").on("click", "a.colapse", function () {
  $(this)
    .parent()
    .find("ul")
    .removeClass("expanded")
    .stop(true, true)
    .slideUp();
  $(this).parent().find("a.colapse").hide();
  $(this).parent().find("a.expand").show();
});

var backButton = $(".hamburger .back-button");

$(".hamburger").on("click", function () {
  $(this).toggleClass("is-active");
  backButton.toggleClass("is-active");
  $(".header-container").toggleClass("navi-open");
  $("body").toggleClass("navi-open");
  $(".menu-wrapper").toggleClass("navi-open");
});

$(".show-more").on("click", function () {
  $(this).closest("li.level1").find("ul.level2").toggle();
  $(this).closest("li.level1").toggleClass("open");
});

$("#navigacija a").on("click", function () {
  $(".hamburger").removeClass("is-active");
  $(".header-container").removeClass("navi-open");
  $("body").removeClass("navi-open");
  $(".menu-wrapper").removeClass("navi-open");
});
/**** Main menu end ****/

$(window).on("scroll", function () {
  var scrollTop = $(this).scrollTop();
  $(".header-container .logo-img-color").hide();

  if (scrollTop > 50) {
    $(".header-container").addClass("sticky");
    $(".header-container .logo-img").hide();
    $(".header-container .logo-img-color").show();
  } else {
    $(".header-container").removeClass("sticky");
    $(".header-container .logo-img").show();
    $(".header-container .logo-img-color").hide();
  }
});


$(".menu-wrapper a[href^='#']").on("click", function(e) {
  var href = $(this).attr("href");
  var hash = href.substring(href.indexOf("#"));
  var target = $(hash);

  if (target.length) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: target.offset().top - 50
    }, 800);
  } else {
    window.location.href = "/" + hash;
  }
});